<template>
  <div>
    <CToaster :autohide="3000">
      <template v-for="info in infoList">
        <CToast
          :key="info.message"
          :show="true"
          :header="info.header"
          :color="info.color"
        >
          {{ info.message }}.
        </CToast>
      </template>
    </CToaster>
    <CRow>
      <CCol col="12" lg="12">
        <CCard>
          <CCardHeader> <strong>General</strong> Settings </CCardHeader>
          <CCardBody>
            <CForm>
              <CInput
                label="Location Name"
                horizontal
                v-model="configurationObj.locationName"
                readonly
              />
              <CInput
                label="Location Code"
                horizontal
                v-model="configurationObj.locationCode"
                readonly
              />
              <CInput
                label="Serial Number"
                horizontal
                v-model="configurationObj.serialNumber"
                readonly
              />
              <CInput
                label="Longitude"
                horizontal
                v-model="configurationObj.longitude"
                readonly
              />
              <CInput
                label="Latitude"
                horizontal
                v-model="configurationObj.latitude"
                readonly
              />
              <CInput
                label="Phone No"
                horizontal
                v-model="configurationObj.phoneNo"
                readonly
              />
              <CInput
                label="IP Address"
                horizontal
                v-model="configurationObj.ipAddress"
                readonly
              />
            </CForm>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="onEdit">Edit</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <!-- <CRow>
      <CCol col="12" lg="12">
        <CCard>
          <CCardBody
            ><CButton color="primary" @click="onEdit">Edit</CButton></CCardBody
          >
        </CCard>
      </CCol>
    </CRow> -->
  </div>
</template>

<script>
import ConfigurationApi from "../../lib/configurationApi";

export default {
  name: "Setting",
  data() {
    return {
      infoList: [],

      api: new ConfigurationApi(),
      configurationObj: {},
      equipmentStatusObj: {},
    };
  },
  mounted() {
    var self = this;
    self.resetObj();
  },
  computed: {},
  methods: {
    onEdit() {
      var self = this;
      self.$router.push({
        path: `/settings/settingEdit`,
      });
    },
    resetObj() {
      var self = this;
      this.api
        .getLatest()
        .then((response) => {
          self.configurationObj = response.result;
        })
        .catch((data) => {
          self.toast("Error", data, "danger");
        });

    },
    toast(header, message, color) {
      var self = this;
      self.infoList.push({
        header: header,
        message: message,
        color: color,
      });
    },
  },
};
</script>
